# Ad selection

The SEEK API provides access to SEEK’s suite of ad products.

By integrating ad selection into your posting flow, hirers will be able to:

- Select an ad product based on their contractual arrangement with SEEK.

- View prices in real time for each ad product.

  [Prices vary] by role and market factors.

- Understand how they will be billed for each job ad posted.

- View additional fields relevant to the [ad product’s features], such as [brands] and search bullets.

[ad product’s features]: /schema/named-type/AdvertisementProductFeatures
[brands]: /use-cases/job-posting/branding
[prices vary]: https://help.au.employer.seek.com/s/article/How-much-does-it-cost-to-post-a-job-ad

## Using ad selection

import { Alert, Text } from 'braid-design-system';

<Alert tone="promote">
  <Text>
    SEEK strongly recommends using the Ad Selection Panel for your integration.
    It will significantly reduce development time and ongoing maintenance, as
    well as provide an up-to-date user experience for SEEK hirers.
  </Text>
</Alert>

### Option 1: Ad Selection Panel

SEEK offers an Ad Selection Panel that you can embed into your posting flow:

import { AdSelectionPanel } from './ad-selection/v2/AdSelectionPanel';
import { ClientOnly } from '#src/components/ClientOnly.tsx';

<ClientOnly>
  <AdSelectionPanel mode="panel" />
</ClientOnly>

Jump to the [panel section](/use-cases/job-posting/ad-selection/v2/panel) to get started.

### Option 2: GraphQL

Available ad products can be programmatically retrieved by your software when [posting] or [updating] a job ad.
This allows you to build your own custom user interface for ad selection.

Jump to the [GraphQL section](/use-cases/job-posting/ad-selection/v2/graphql) to get started.

[posting]: /use-cases/job-posting/managing-job-ads/posting-a-job-ad
[updating]: /use-cases/job-posting/managing-job-ads/updating-a-job-ad
